import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import {ListItem} from "src/app/entities/list-item.entity";
import {ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import Process = Backend.App.Resources.Dashboard.QualityManagement.Process;
import ProcessData = Backend.App.Data.Dashboard.QualityManagement.ProcessData;

@Injectable({providedIn: 'root'})
export class AddableProcessesService extends BaseEndpointService<Process, ProcessData> {
  public override resolve(route: ActivatedRouteSnapshot): Observable<Process> {
    const process = route.parent?.data['process'];
    if (process) this.forProcess(process);
    return this.get(route.params['id']).pipe(map(r => r.data));
  }

  public forProcess(process: Process) {
    this.endpoint = `/quality-management/processes/${process.id}/addable-processes`;
  }

  public override modelToMultiSelectItem(m: Process): ListItem & { model: Process; } {
    return {
      id: m.id,
      text: m.title ?? m.ext_id,
      isDisabled: false,
      model: m,
    }
  }
}
